import React, { useContext } from 'react';

// Components
import Topic from '../components/Topic/Topic';
import ConnectSection from '../components/Sections/ConnectSection';
import ReachForm from '../components/Form/ReachForm';
import { ApiContext } from '../context/api/apiContext';

import IconPlane from '../i/icons/plane.svg';
import IconRoute from '../i/icons/route.svg';

const Help = (props) => {
	const { jsonData } = useContext(ApiContext);

	const {
		heroSection,
		joinSection,
		connectSection,
		reachOutSection
	} = jsonData.pages.help;

	return (
		<React.Fragment>
			<section className="section hero_v3_mod center_level_mod bottom_decor_mod">
				<div className="section_bg loaded_mod" style={{ backgroundImage: `url(${heroSection.bgImage})` }} />
				<div className="section_in inner_hero_mod">
					<h2 className="section_title center_level_mod hero_v1_mod">{heroSection.title}</h2>
				</div>
			</section>
			<section className="section">
				<div className="section_in">
					<h2 className="section_title accent_mod center_level_mod offset_mod">{joinSection.title}</h2>
					<div className="section_descr accent_mod center_mod offset_v2_mod">{joinSection.subtitle}</div>
					<div className="topic_list">
						{joinSection.topicList.map(({ name, description }, index) => {
							return (
								<div className="topic_item_wrap" key={index}>
									<Topic
										name={name}
										descr={description}
									/>
								</div>
							)
						})}
					</div>
				</div>
			</section>
			<section className="section">
				<div className="section_in">
					<div className="reach_wrap">
						<div className="reach_col offset_mod">
							<h2 className="section_title accent_mod offset_mod">{reachOutSection.title}</h2>
							<div className="section_descr accent_mod offset_v2_mod">{reachOutSection.description}</div>
							<ReachForm />
						</div>
						<div className="reach_col">
							<div className="reach_list">
								{reachOutSection.contactBlocks.map(({ title, link, url, description }, index) => {

									const icons = [<IconPlane className="icon size_mod" />, <IconRoute className="icon size_mod" />];

									return (
										<div className="reach_item_wrap" key={index}>
											<div className="reach_item">
												<div className="reach_icon_wrap">
													<div className={`reach_icon_in ${index === 1 ? 'lg_mod' : ''}`}>
														{icons[index]}
													</div>
												</div>
												<div className="reach_title">{title}</div>
												{link && (
													<a className="reach_text link_mod" href={url}>{link}</a>
												)}
												{description && (
													<div className="reach_text">{description}</div>
												)}
											</div>
										</div>
									)
								})}
							</div>
						</div>
					</div>
				</div>
			</section>
			<ConnectSection
				bgImg={connectSection.bgImage}
				title={connectSection.title}
				description={connectSection.description}
				buttonTitle={connectSection.buttonTitle}
				buttonUrl={connectSection.buttonUrl}
			/>
		</React.Fragment>

	)
};

export default Help;